module.exports = __webpack_public_path__ + "static/img/celoscope-detail-38.d7f1eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-38.jpg
// module id = kDLh
// module chunks = 51